import { Injectable } from '@angular/core';

@Injectable()
export class UrlService {

  private regEx = /^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/i;

  constructor() {}

  public getHost(url: string): string {
    return this.getSection(url, 4);  // hostname and port number
  }

  private getSection(url: string, sectionIndex: number) {
    const match = url.match(this.regEx);
    if (match != null && match.length > sectionIndex && typeof match[sectionIndex] === 'string' && match[sectionIndex].length > 0) {
      return match[sectionIndex];
    } else {
      return null;
    }
  }
}
